const signInUrl = "/authentication/sign-in";
const directusRoleId = "1";

// eslint-disable-next-line import/prefer-default-export
export { signInUrl, directusRoleId };
